export default "__VITE_ASSET__c07d48c2__"